import React, { memo } from "react";
import useComponentVisible from "../OutsideClick/useComponentVisible";
import { Link } from "react-router-dom";

function ProfileDropdown({
  isAuthenticated,
  userLogin,
  logOutUser,
  prosuiteDetails,
  IsDashBoardLawfirmSelected,
  multipleFirmsUser,
  lang,
  t,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  return (
    <>
      {isAuthenticated && (
        <div ref={ref}>
          <li className="bg-secondary-green">
            <button
              type="button"
              onClick={() =>
                setIsComponentVisible((prev) => {
                  return !prev;
                })
              }
              className="flex items-center justify-between w-full px-8 py-4 text-white outline-none border-[1px] border-transparent focus-visible:border focus-visible:border-primary-yellow focus:border focus:border-primary-yellow hover:bg-secondary-green-hover"
            >
              {userLogin.firstName}
              <svg
                className="w-5 h-5 ml-1"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>

            {isComponentVisible && (
              <div className="z-10 font-normal bg-white divide-y divide-gray-100  w-[187px] ">
                <ul
                  className="py-1 text-sm text-neutrals-black w-full"
                  aria-labelledby="dropdownLargeButton"
                >
                  {prosuiteDetails === null && (
                    <li>
                      <a
                        href={
                          lang?.value === "en"
                            ? "../../Documents/EN_CA/CTIC_Agency_Agreement_En.pdf"
                            : "../../Documents/FR_CA/CTIC_Agency_Agreement_Fr.pdf"
                        }
                        target="_blank"
                        className="block  w-full px-4 py-2 text-neutrals-black
                    hover:bg-primary-yellow-100 hover:text-shadow focus-visible:outline-none
                    focus:bg-primary-yellow-100 focus:text-shadow"
                      >
                        {t("AgencyAgreement")}
                      </a>
                    </li>
                  )}

                  {prosuiteDetails === null && (
                    <li>
                      <Link
                        to="/accountsettings"
                        state={{ Tab: 0 }}
                        className="block  w-full px-4 py-2 text-neutrals-black
                    hover:bg-primary-yellow-100 hover:text-shadow focus-visible:outline-none
                    focus:bg-primary-yellow-100 focus:text-shadow"
                      >
                        Account Summary
                      </Link>
                    </li>
                  )}
                  {prosuiteDetails === null && (
                    <li>
                      <Link
                        to="/orderstatus?tab=3"
                        state={{ Tab: 4, SubTab: 1 }}
                        className="block  w-full px-4 py-2 text-neutrals-black
                          hover:bg-primary-yellow-100 hover:text-shadow focus-visible:outline-none
                          focus:bg-primary-yellow-100 focus:text-shadow"
                      >
                        Make a Payment
                      </Link>
                    </li>
                  )}
                  {prosuiteDetails === null && (
                    <li>
                      <Link
                        to="/accountsettings"
                        state={{ Tab: 1 }}
                        className="block  w-full px-4 py-2 text-neutrals-black
                    hover:bg-primary-yellow-100 hover:text-shadow focus-visible:outline-none
                    focus:bg-primary-yellow-100 focus:text-shadow"
                      >
                        Manage Billing
                      </Link>
                    </li>
                  )}

                  {prosuiteDetails === null && (
                    <li>
                      <Link
                        to="/orderstatus?tab=3"
                        state={{ Tab: 4, SubTab: 2 }}
                        className="block  w-full px-4 py-2 text-neutrals-black
                        hover:bg-primary-yellow-100 hover:text-shadow focus-visible:outline-none
                        focus:bg-primary-yellow-100 focus:text-shadow"
                      >
                        Review Payments
                      </Link>
                    </li>
                  )}

                  {prosuiteDetails === null && (
                    <li>
                      <Link
                        to="/changepassword"
                        className="block  w-full px-4 py-2 text-neutrals-black
                        hover:bg-primary-yellow-100 hover:text-shadow focus-visible:outline-none
                        focus:bg-primary-yellow-100 focus:text-shadow"
                      >
                        Change Password
                      </Link>
                    </li>
                  )}

                  <li>
                    <a
                      onClick={logOutUser}
                      // href="/"
                      className="block w-full px-4 py-2 text-neutrals-black font-semibold
                            focus-visible:outline-none focus:text-shadow hover:text-shadow
                            "
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </li>
        </div>
      )}
    </>
  );
}

export default memo(ProfileDropdown);
